import React from "react";
import { Alert } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { ApiError } from "go-core/api/types";
import { selectOrganization } from "../../../../../../../services/organizations/selectors";

interface Props {
	errors: ApiError[];
}

const SubscriptionErrorsDisplay = (props: Props) => {
	const organization = useSelector(selectOrganization);
	const { errors } = props;
	const { t } = useTranslation();

	return (
		<>
			<div className={"content-preview"}>
				{errors[0].code === "customer_not_found" && (
					<Alert variant={"danger"}>
						<span className={"me-1"}>{t("modules.subscription.field.customer_not_found.title")}</span>
					</Alert>
				)}
				{errors[0].code === "missing_customer_data" && (
					<Alert variant={"danger"}>
						<span className={"me-1"}>{t("constraints.missing_customer_data")},</span>
						<Link target={"_blank"} rel={"no_referrer"} to={`/${organization.id}/settings/invoice_details`}>
							{t("modules.subscription.field.fill_invoice_details.title")}
						</Link>
					</Alert>
				)}
			</div>
		</>
	);
};
export default SubscriptionErrorsDisplay;
